export function toTimestamp(value) {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : 0;
  }

  if (typeof value !== "string") return 0;

  const trimmed = value.trim();
  if (!trimmed) return 0;

  const numeric = Number(trimmed);
  if (Number.isFinite(numeric)) return numeric;

  const parsed = new Date(trimmed).getTime();
  return Number.isFinite(parsed) ? parsed : 0;
}

export function getLatestAbuseHistoryAt(rows = []) {
  if (!Array.isArray(rows) || rows.length === 0) return 0;
  return Math.max(...rows.map((row) => toTimestamp(row?.createdAt)));
}

export function getLatestProfitAlertAt(rows = []) {
  if (!Array.isArray(rows) || rows.length === 0) return 0;
  return Math.max(...rows.map((row) => toTimestamp(row?.triggeredAt)));
}
